import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAuth } from '@/context/AuthContext';
import { sidebarIsCollapsedSelector, toggleSidebar } from '@/store/sidebar/sidebarSlices';
import logo from '@/img/propsavvy-logo-with-text.svg';
import { TenantMenu } from '../Navbar/TenantMenu';
import { OwnerManagerMenu } from '../Navbar/OwnerManagerMenu';
import './UISideBar.scss';

const UISideBar: React.FC = () => {
  const { isOwner, isManager, isTenant } = useAuth();
  const isCollapsed = useSelector(sidebarIsCollapsedSelector);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleSidebar());
  };

  const renderMenu = () => {
    if (isTenant) {
      return <TenantMenu isCollapsed={isCollapsed} />;
    }
    if (isOwner || isManager) {
      return <OwnerManagerMenu isOwner={isOwner} isCollapsed={isCollapsed} />;
    }
    return null;
  };

  return (
    <div className={`ui-sidebar ${isCollapsed ? 'ui-sidebar--collapsed' : ''}`}>
      <div className="ui-sidebar__header">
        {!isCollapsed && (
          <div className="ui-sidebar__logo">
            <img className="ui-sidebar__logo-img" src={logo} alt="logo" />
          </div>
        )}

        <button
          className="ui-sidebar__toggle"
          onClick={handleToggle}
          aria-label="Toggle sidebar"
        >
          <i className={`fa-solid ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
        </button>
      </div>

      <nav className="ui-sidebar__nav">
        <ul className="ui-sidebar__nav-list">
          {renderMenu()}
        </ul>
      </nav>
    </div>
  );
};

export default UISideBar;